import { render, staticRenderFns } from "./SedativeContent.vue?vue&type=template&id=46264049&"
import script from "./SedativeContent.vue?vue&type=script&lang=js&"
export * from "./SedativeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports